import { Box, Button, Flex, Image, Text } from '@chakra-ui/react';
import axios from 'axios';
import { useContext, useEffect, useState } from 'react';
import { AiFillDislike, AiFillLike } from 'react-icons/ai';
import ReactPaginate from 'react-paginate';
import { Link } from 'react-router-dom';
import UserContext from '../../context/userContext';
import Landscape from './landscape.jpg';
import './MovieList.css';

const MovieList = () => {
  const { userData } = useContext(UserContext);
  const user = userData.user;
  console.log('user is list', user);
  const itemsPerPage = 20;
  const [movies, setMovies] = useState([]);
  const [pageCount, setPageCount] = useState(1);
  const [page, setPage] = useState(1);
  const [itemOffset, setItemOffset] = useState(0);
  useEffect(() => {
    setPageCount(Math.ceil(23530 / itemsPerPage - 1));
    const getMovies = async () => {
      const response = await axios.get(
        `https://mern-stack-movies-app.herokuapp.com/movies?page=${page}&limit=20`
      );
      setMovies(response.data);
    };
    getMovies();
  }, [movies.length, pageCount, itemOffset, page]);

  const handlePageClick = event => {
    const newOffset = (event.selected * itemsPerPage) % 23530;
    console.log(
      `User requested page number ${event.selected}, which is offset ${newOffset}`
    );
    setItemOffset(newOffset);
    setPage(Math.floor(newOffset / itemsPerPage + 1));
  };

  const likePost = id => {
    let token = localStorage.getItem('auth-token');
    fetch('https://mern-stack-movies-app.herokuapp.com/movies/like', {
      method: 'put',
      headers: {
        'Content-Type': 'application/json',
        'x-auth-token': token,
      },
      body: JSON.stringify({
        postId: id,
      }),
    })
      .then(res => res.json())
      .then(result => {
        const newData = movies.map(movie => {
          if (movie._id === result._id) {
            return result;
          } else {
            return movie;
          }
        });
        setMovies(newData);
      })
      .catch(err => {
        console.log(err);
      });
  };

  const unlikePost = id => {
    let token = localStorage.getItem('auth-token');
    fetch('https://mern-stack-movies-app.herokuapp.com/movies/unlike', {
      method: 'put',
      headers: {
        'Content-Type': 'application/json',
        'x-auth-token': token,
      },
      body: JSON.stringify({
        postId: id,
      }),
    })
      .then(res => res.json())
      .then(result => {
        const newData = movies.map(movie => {
          if (movie._id === result._id) {
            return result;
          } else {
            return movie;
          }
        });
        setMovies(newData);
      })
      .catch(err => {
        console.log(err);
      });
  };

  const addFavorites = id => {
    let token = localStorage.getItem('auth-token');
    fetch('https://mern-stack-movies-app.herokuapp.com/movies/addFavorites', {
      method: 'put',
      headers: {
        'Content-Type': 'application/json',
        'x-auth-token': token,
      },
      body: JSON.stringify({
        postId: id,
      }),
    })
      .then(res => res.json())
      .then(result => {
        const newData = movies.map(movie => {
          if (movie._id === result._id) {
            return result;
          } else {
            return movie;
          }
        });
        setMovies(newData);
      })
      .catch(err => {
        console.log(err);
      });
  };

  const removeFavorites = id => {
    let token = localStorage.getItem('auth-token');
    fetch(
      'https://mern-stack-movies-app.herokuapp.com/movies/removeFavorites',
      {
        method: 'put',
        headers: {
          'Content-Type': 'application/json',
          'x-auth-token': token,
        },
        body: JSON.stringify({
          postId: id,
        }),
      }
    )
      .then(res => res.json())
      .then(result => {
        const newData = movies.map(movie => {
          if (movie._id === result._id) {
            return result;
          } else {
            return movie;
          }
        });
        setMovies(newData);
      })
      .catch(err => {
        console.log(err);
      });
  };

  return (
    <Box mb={10}>
      <ReactPaginate
        breakLabel="..."
        nextLabel="next >"
        onPageChange={handlePageClick}
        pageRangeDisplayed={3}
        pageCount={pageCount}
        previousLabel="< previous"
        renderOnZeroPageCount={null}
        containerClassName={'pagination'}
        previousLinkClassName={'pagination__link'}
        nextLinkClassName={'pagination__link'}
        disabledClassName={'pagination__link--disabled'}
        activeClassName={'pagination__link--active'}
      />
      <Flex direction="row" wrap="wrap" justify="center">
        {movies ? (
          movies.map((movie, index) => {
            return (
              <Flex
                key={index}
                direction="column"
                align="center"
                justify="start"
                textAlign="center"
                w="300px"
                border="2px solid #000"
                mt={10}
                mx={5}
                pb={5}
                bg="#e8ecf1"
                overflow="hidden"
              >
                <Image
                  alt=""
                  src={
                    movie.poster === undefined
                      ? `${Landscape}`
                      : `${movie.poster}`
                  }
                  transition="transform 0.5s ease"
                  _hover={{
                    transform: 'translateY(80px) scale(2.0)',
                  }}
                  pb={5}
                />
                <Box pb={5} pl={5} pr={5}>
                  <Text fontSize="lg" fontWeight="700" as="u" color="#ff0000">
                    Title
                  </Text>
                  <Text fontSize="lg" color="#000" mt={2} mb={2}>
                    {movie.title}
                  </Text>
                  <Link to={'/movie/' + movie._id}>
                    <Button
                      bg="#f9bf3b"
                      _hover={{
                        background: '#ff0000',
                        color: '#fff',
                      }}
                    >
                      Show info
                    </Button>
                  </Link>
                </Box>
                {user ? (
                  movie.likes.includes(user.id) ? (
                    <AiFillDislike
                      onClick={() => {
                        unlikePost(movie._id);
                      }}
                      style={{ fontSize: 24, marginLeft: 20 }}
                    />
                  ) : (
                    <AiFillLike
                      onClick={() => {
                        likePost(movie._id);
                      }}
                      style={{ fontSize: 24 }}
                    />
                  )
                ) : (
                  <Box>
                    <Flex mt={1} direction="row" wrap="wrap" justify="center">
                      <AiFillLike style={{ fontSize: 24 }} />
                      <AiFillDislike style={{ fontSize: 24, marginLeft: 20 }} />
                    </Flex>
                  </Box>
                )}
                <Text fontSize="lg" color="#000" mt={2} mb={2}>
                  {movie.likes.length} likes
                </Text>
                <Text
                  fontSize="lg"
                  fontWeight="700"
                  mb={3}
                  as="u"
                  color="#ff0000"
                >
                  Add to favorites
                </Text>
                {user ? (
                  movie.favorites.includes(user.id) ? (
                    <AiFillDislike
                      onClick={() => {
                        removeFavorites(movie._id);
                      }}
                      style={{ fontSize: 24, color: '#ff0000' }}
                    />
                  ) : (
                    <AiFillLike
                      onClick={() => {
                        addFavorites(movie._id);
                      }}
                      style={{ fontSize: 24, color: '#ff0000' }}
                    />
                  )
                ) : (
                  <Box>
                    <Flex mt={1} direction="row" wrap="wrap" justify="center">
                      <AiFillLike style={{ fontSize: 24, color: '#ff0000' }} />
                      <AiFillDislike
                        style={{
                          fontSize: 24,
                          color: '#ff0000',
                          marginLeft: 20,
                        }}
                      />
                    </Flex>
                  </Box>
                )}
              </Flex>
            );
          })
        ) : (
          <Box className="alert">
            <Text fontWeight="700">No movies found</Text>
          </Box>
        )}
      </Flex>
    </Box>
  );
};

export default MovieList;
